module.exports = __webpack_public_path__ + "static/media/pesuio.3b369f16.png";